import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../Menu1.css"; // Import the custom CSS
import { logout } from "../redux/actions/authAction";

const Navbar = () => {
	const { auth } = useSelector((state) => state);
	const isInstructor = localStorage.getItem("instructor");
	const dispatch = useDispatch();
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
	const mobileMenuRef = useRef(null);
	const mobileMenuOverlayRef = useRef(null);
	const [dropdownOpen, setDropdownOpen] = useState(null);
	// const downloadPdf = usePdfDownloader();

	const toggleMobileMenu = () => {
		setMobileMenuOpen(!mobileMenuOpen);
	};

	const toggleDropdown = (index) => {
		setDropdownOpen(dropdownOpen === index ? null : index);
	};

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth > 1112 && mobileMenuOpen) {
				setMobileMenuOpen(false);
			}
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, [mobileMenuOpen]);

	useEffect(() => {
		if (mobileMenuOpen) {
			document.body.style.overflow = "hidden";
			document.documentElement.style.overflow = "hidden"; // add this
		} else {
			document.body.style.overflow = "";
			document.documentElement.style.overflow = ""; // and reset it here
		}
	}, [mobileMenuOpen]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			// Check if the click was outside the mobile menu and overlay
			if (
				mobileMenuRef.current &&
				!mobileMenuRef.current.contains(event.target) && // Click outside the menu
				!mobileMenuOverlayRef.current.contains(event.target) // Click outside the overlay
			) {
				setMobileMenuOpen(false); // Close the menu
			}
		};

		if (mobileMenuOpen) {
			document.addEventListener("mousedown", handleClickOutside); // Listen for outside clicks
		} else {
			document.removeEventListener("mousedown", handleClickOutside); // Cleanup
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside); // Cleanup on unmount
		};
	}, [mobileMenuOpen]);

	return (
		<div className="menu-bar v2">
			{/* Menu Bar Start */}
			<div>
				<div>
					<div className="menu-bar-content">
						{/* Logo Section */}
						<div className="menu-logo">
							<a href="/">
								<img
									href="/"
									src="../images/main-logo.png"
									alt="logo"
									height={100}
									width={"100%"}
								/>
							</a>

							{/* <div className="logo-text-container">
								<span className="logo-divider"></span>
								<a
									className="logo-text nav-links"
									href="/"
									style={{ padding: "0" }}>
									GLOBAL ACADEMY <br /> FOR FOOD SAFETY AND <br />
									SUSTAINABLE STANDARDS
								</a>
							</div> */}
						</div>

						{/* Navigation Menu */}
						<nav className="main-menu">
							<ul className="menu-list">
								<li className="menu-item nav-item">
									<a title="Home" href="/home" className="nav-links">
										Home
									</a>
								</li>

								{/* About Us Dropdown */}
								<li className="menu-item menu-item-has-children nav-item">
									<a
										title="About Us"
										href="#"
										className="nav-links"
										aria-expanded={dropdownOpen === 1}
										onClick={(e) => {
											e.preventDefault();
											toggleDropdown(1);
										}}>
										About Us
										<span className="dropdown-arrow"></span>
									</a>
									{dropdownOpen === 1 && (
										<ul className="submenu">
											<li className="menu-item">
												<a
													title="Key Objectives"
													href="/keyobjectives"
													className="dropdown-items">
													Key Objectives
												</a>
											</li>
											<li className="menu-item">
												<a
													title="Company Profile"
													href="/companyprofile"
													className="dropdown-items">
													Company Profile
												</a>
											</li>
											<li className="menu-item">
												<a
													title="Our Team"
													href="/ourteam"
													className="dropdown-items">
													Our Team
												</a>
											</li>
											<li className="menu-item">
												<a
													title="Experts"
													href="/experts"
													className="dropdown-items">
													Experts
												</a>
											</li>
										</ul>
									)}
								</li>
								<li className="menu-item menu-item-has-children nav-item">
									<a
										title="What We Do"
										href="#"
										className="nav-links"
										aria-expanded={dropdownOpen === 2}
										onClick={(e) => {
											e.preventDefault();
											toggleDropdown(2);
										}}>
										What We Do
										<span className="dropdown-arrow"></span>
									</a>
									{dropdownOpen === 2 && (
										<ul className="submenu">
											<li className="menu-item">
												<a
													title="Problem Statement"
													href="/problemstatement"
													className="dropdown-items">
													Problem Statement
												</a>
											</li>
											<li className="menu-item">
												<a
													title="Our Approach"
													href="/ourapproach"
													className="dropdown-items">
													Our Approach
												</a>
											</li>
											<li className="menu-item">
												<a
													title="Platform Features"
													href="/platformfeatures"
													className="dropdown-items">
													Platform Features
												</a>
											</li>
											<li className="menu-item">
												<a
													title="Standards Coverage"
													href="/standardscoverage"
													className="dropdown-items">
													Standards Coverage
												</a>
											</li>
											<li className="menu-item">
												<a
													title="Target Audience"
													href="/targetaudience"
													className="dropdown-items">
													Target Audience
												</a>
											</li>
											<li className="menu-item">
												<a
													title="Impact Creation"
													href="/impactcreation"
													className="dropdown-items">
													Impact Creation
												</a>
											</li>
										</ul>
									)}
								</li>
								<li className="menu-item nav-item">
									<a
										title="students"
										href="/courses/9ae8b71c-dd3f-4fad-b1ee-e872f951e7af"
										className="nav-links">
										Courses
									</a>
								</li>
								<li className="menu-item nav-item">
									<a
										onClick={() =>
											window.open(
												"../brochures/FARMER_ORGANIZATIONS_BROCHURE-1-7-25.pdf",
												"_blank",
											)
										}
										title="AgriGrowth"
										// href="/modelfarm"
										className="nav-links">
										AgriGrowth
									</a>
								</li>
								{/* <li className="menu-item nav-item">
									<a
										title="agripreneurs"
										href="/agripreneurs"
										className="nav-links">
										Agripreneurs
									</a>
								</li> */}

								{/* What We Do Dropdown */}

								{/* FAQ's and Contact Us Links */}
								<li className="menu-item nav-item">
									<a title="FAQ's" href="/faqs" className="nav-links">
										FAQ’s
									</a>
								</li>
								{/* <li className="menu-item nav-item">
									<a title="Events" href="/events" className="nav-links">
										Events
									</a>
								</li> */}
								<li className="menu-item nav-item">
									<a title="Contact Us" href="/contactus" className="nav-links">
										Contact Us
									</a>
								</li>
								<li className="menu-item nav-item">
									{auth.user === undefined && isInstructor === null ? (
										<a title="Log In" href="/login" className="nav-links">
											<i
												className="fa fa-user"
												aria-hidden="true"
												style={{ marginRight: "8px" }}></i>
											Log In
										</a>
									) : (
										<>
											<a
												title="Logout"
												href="/login"
												onClick={() => dispatch(logout())}
												className="nav-links">
												<i
													className="fa fa-sign-out"
													aria-hidden="true"
													style={{ marginRight: "8px" }}></i>
												Logout
											</a>
										</>
									)}
								</li>
							</ul>
						</nav>

						{/* Mobile Menu Button */}
						<button
							className="mobile-menu-btn"
							onClick={toggleMobileMenu}
							aria-label="Toggle mobile menu">
							<span
								style={{
									height: "2px",
									width: "100%",
									background: "#000",
								}}></span>
							<span
								style={{
									height: "2px",
									width: "100%",
									background: "#000",
								}}></span>
							<span
								style={{
									height: "2px",
									width: "100%",
									background: "#000",
								}}></span>
						</button>

						{/* Mobile Menu */}
						{mobileMenuOpen && (
							<div className="mobile-menu" ref={mobileMenuRef}>
								<div className="mobile-header">
									{/* <div className="mobile-logo">
                    <a
                      className="standard-logo"
                      href="https://digitalvega.in/foodsafetyacademy/"
                    >
                      <img
                        src="https://digitalvega.in/foodsafetyacademy/wp-content/uploads/2024/10/main-logo-1.png"
                        alt="logo"
                      />
                    </a>
                  </div> */}
									<button
										className="mobile-menu-btn"
										onClick={toggleMobileMenu}
										style={{
											fontSize: "24px",
											fontWeight: "bold",
											background: "none",
											border: "none",
											cursor: "pointer",
											color: "#000",
											marginBottom: "12px",
										}}>
										{/* <span className="my-icon icon-angle-arrow-left"></span> */}
										{/* <span
                      style={{
                        height: "2px",
                        width: "100%",
                        background: "#000",
                      }}
                    ></span>
                    <span
                      style={{
                        height: "2px",
                        width: "100%",
                        background: "#000",
                      }}
                    ></span>
                    <span
                      style={{
                        height: "2px",
                        width: "100%",
                        background: "#000",
                      }}
                    ></span> */}
										x
									</button>
								</div>
								<div className="mobile-overflow">
									<nav className="main-manu">
										{/* <ul id="menu-our-menu">
                      <li className="menu-item nav-item">
                        <a
                          title="Home"
                          href="https://digitalvega.in/foodsafetyacademy/home/"
                          className="nav-links"
                        >
                          Home
                        </a>
                      </li>
                    </ul> */}
										<ul className="menu-list">
											<li className="menu-item nav-item">
												<a title="Home" href="/home" className="nav-links">
													Home
												</a>
											</li>
											{/* About Us Dropdown */}
											<li className="menu-item menu-item-has-children nav-item">
												<a
													title="About Us"
													href="#"
													className="nav-links"
													aria-expanded={dropdownOpen === 1}
													onClick={(e) => {
														e.preventDefault();
														toggleDropdown(1);
													}}>
													About Us
													<span className="dropdown-arrow"></span>
												</a>
												{dropdownOpen === 1 && (
													<ul className="submenu">
														<li className="menu-item">
															<a
																title="Key Objectives"
																href="/keyobjectives"
																className="dropdown-items">
																Key Objectives
															</a>
														</li>
														<li className="menu-item">
															<a
																title="Company Profile"
																href="/companyprofile"
																className="dropdown-items">
																Company Profile
															</a>
														</li>
														<li className="menu-item">
															<a
																title="Our Team"
																href="/ourteam"
																className="dropdown-items">
																Our Team
															</a>
														</li>
														<li className="menu-item">
															<a
																title="Experts"
																href="/experts"
																className="dropdown-items">
																Experts
															</a>
														</li>
													</ul>
												)}
											</li>
											<li className="menu-item menu-item-has-children nav-item">
												<a
													title="What We Do"
													href="#"
													className="nav-links"
													aria-expanded={dropdownOpen === 2}
													onClick={(e) => {
														e.preventDefault();
														toggleDropdown(2);
													}}>
													What We Do
													<span className="dropdown-arrow"></span>
												</a>
												{dropdownOpen === 2 && (
													<ul className="submenu">
														<li className="menu-item">
															<a
																title="Problem Statement"
																href="/problemstatement"
																className="dropdown-items">
																Problem Statement
															</a>
														</li>
														<li className="menu-item">
															<a
																title="Our Approach"
																href="/ourapproach"
																className="dropdown-items">
																Our Approach
															</a>
														</li>
														<li className="menu-item">
															<a
																title="Platform Features"
																href="/platformfeatures"
																className="dropdown-items">
																Platform Features
															</a>
														</li>
														<li className="menu-item">
															<a
																title="Standards Coverage"
																href="/standardscoverage"
																className="dropdown-items">
																Standards Coverage
															</a>
														</li>
														<li className="menu-item">
															<a
																title="Target Audience"
																href="/targetaudience"
																className="dropdown-items">
																Target Audience
															</a>
														</li>
														<li className="menu-item">
															<a
																title="Impact Creation"
																href="/impactcreation"
																className="dropdown-items">
																Impact Creation
															</a>
														</li>
													</ul>
												)}
											</li>
											<li className="menu-item nav-item">
												<a
													title="students"
													href="/courses/9ae8b71c-dd3f-4fad-b1ee-e872f951e7af"
													className="nav-links">
													Courses
												</a>
											</li>
											<li className="menu-item nav-item">
												<a
													title="AgriGrowth"
													// href="/modelfarm"
													onClick={() =>
														window.open(
															"../brochures/FARMER ORGANIZATIONS BROCHURE - 1-7-25.pdf",
															"_blank",
														)
													}
													className="nav-links">
													AgriGrowth
												</a>
											</li>
											{/* <li className="menu-item nav-item">
												<a
													title="agripreneurs"
													href="/agripreneurs"
													className="nav-links">
													Agripreneurs
												</a>
											</li> */}

											{/* What We Do Dropdown */}

											{/* FAQ's and Contact Us Links */}
											<li className="menu-item nav-item">
												<a title="FAQ's" href="/faqs" className="nav-links">
													FAQ’s
												</a>
											</li>
											{/* <li className="menu-item nav-item">
												<a title="FAQ's" href="/events" className="nav-links">
													Events
												</a>
											</li> */}
											<li className="menu-item nav-item">
												<a
													title="Contact Us"
													href="/contactus"
													className="nav-links">
													Contact Us
												</a>
											</li>
											<li className="menu-item nav-item">
												{auth.user === undefined ? (
													<a title="Log In" href="/login" className="nav-links">
														<i
															className="fa fa-user"
															aria-hidden="true"
															style={{ marginRight: "8px" }}></i>
														Log In
													</a>
												) : (
													<>
														<a
															title="Logout"
															href="/login"
															onClick={() => dispatch(logout())}
															className="nav-links">
															<i
																className="fa fa-sign-out"
																aria-hidden="true"
																style={{ marginRight: "8px" }}></i>
															Logout
														</a>
													</>
												)}
											</li>
										</ul>
									</nav>
								</div>
							</div>
						)}

						{/* Mobile Menu Overlay */}
						<div
							className={`mobile-menu-overlay ${mobileMenuOpen ? "show" : ""}`}
							ref={mobileMenuOverlayRef}
							onClick={() => setMobileMenuOpen(false)}></div>
					</div>
				</div>
			</div>
			{/* Menu Bar End */}
		</div>
	);
};

export default Navbar;
